import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Badge } from '../ui/badge';
import { CalendarClock } from 'lucide-react';
import { format, parseISO, addDays } from 'date-fns';

export const UpcomingDeliveriesCard = ({ sessions = [], projectMetaMap = {}, windowWeeks, onWindowChange, onItemClick, testId = 'upcoming-deliveries-card' }) => {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const cutoff = addDays(today, windowWeeks * 7);

  const upcoming = sessions
    .filter(s => {
      if (!s.session_date) return false;
      const d = parseISO(s.session_date);
      return d >= today && d <= cutoff;
    })
    .sort((a, b) => new Date(a.session_date) - new Date(b.session_date));

  return (
    <Card data-testid={testId}>
      <CardHeader className="flex flex-row items-start justify-between gap-3">
        <div>
          <CardTitle className="font-heading text-base flex items-center gap-2">
            <CalendarClock className="w-4 h-4 text-lime-700" />
            Upcoming Deliveries
          </CardTitle>
          <CardDescription className="text-xs">Next {windowWeeks} week{windowWeeks > 1 ? 's' : ''}, soonest first</CardDescription>
        </div>
        <Select value={String(windowWeeks)} onValueChange={(v) => onWindowChange(parseInt(v, 10))}>
          <SelectTrigger className="w-32 h-8 text-xs" data-testid="upcoming-window-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="2">Next 2 weeks</SelectItem>
            <SelectItem value="4">Next 4 weeks</SelectItem>
          </SelectContent>
        </Select>
      </CardHeader>
      <CardContent>
        {upcoming.length > 0 ? (
          <div className="max-h-72 overflow-y-auto border rounded-lg">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Project</TableHead>
                  <TableHead>Partner</TableHead>
                  <TableHead>Requestor</TableHead>
                  <TableHead>PM</TableHead>
                  <TableHead>Date</TableHead>
                  <TableHead>Session Status</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {upcoming.map(s => {
                  const meta = projectMetaMap[s.project_id] || {};
                  return (
                    <TableRow
                      key={s.id}
                      className="cursor-pointer hover:bg-muted/50"
                      onClick={() => onItemClick && onItemClick(s)}
                      data-testid={`upcoming-row-${s.id}`}
                    >
                      <TableCell className="text-sm font-medium">{s.project_title}</TableCell>
                      <TableCell className="text-sm">{meta.partner_name || '—'}</TableCell>
                      <TableCell className="text-sm">{meta.requestor_name || '—'}</TableCell>
                      <TableCell className="text-sm">{meta.pm_name || '—'}</TableCell>
                      <TableCell className="text-sm">{format(parseISO(s.session_date), 'MMM d, yyyy')}</TableCell>
                      <TableCell><Badge variant="outline" className="text-xs">{s.status}</Badge></TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        ) : (
          <p className="text-center text-muted-foreground py-8 text-sm">No deliveries scheduled in this window</p>
        )}
      </CardContent>
    </Card>
  );
};

export default UpcomingDeliveriesCard;
